module.exports = __webpack_public_path__ + "static/media/BoxPlotQ6_4.3e1ca2ef.svg";